export default "__VITE_ASSET__Cm6uvnG3__"